import { render, staticRenderFns } from "./BrowserStoragePermissionsModal.vue?vue&type=template&id=3396768a"
import script from "./BrowserStoragePermissionsModal.vue?vue&type=script&lang=js"
export * from "./BrowserStoragePermissionsModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports